import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import svgChevron from '@img/icons/interface/chevron-down.svg?url';
import styled, { css } from 'styled-components';
import { CommonTextInputStyles } from '../Textbox/Textbox.styles';
export const CommonSelectStyles = css `
  ${CommonTextInputStyles};

  &:hover {
    cursor: pointer;
  }

  &:read-only,
  &[readonly] {
    color: unset;
  }
`;
export const CommonDropdownWrapperStyles = css `
  --translateY: -50%;

  position: relative;

  &::after {
    ${transition('transform')};

    content: '';
    display: inline-flex;
    align-items: center;
    width: 26px;
    height: 26px;
    position: absolute;
    top: 50%;
  right: 12px;
    transform: translateY(var(--translateY));
    background-color: ${brand.global.white};
    pointer-events: none;
    -webkit-mask-image: url(${svgChevron});
    mask-image: url(${svgChevron});
    mask-repeat: no-repeat;
    background-size: contain;
    background: var(--textColour, currentColor);
  }

  &:focus-within::after {
    transform: translateY(var(--translateY)) rotate(180deg);
  }
`;
const Wrapper = styled.div `
  ${CommonDropdownWrapperStyles};
`;
const Select = styled.select `
  ${CommonSelectStyles};
`;
const SelectStyles = {
    Wrapper,
    Select,
};
export default SelectStyles;
